import { useMemo } from 'react';
import { useTargetingSettingsContext } from '../../../../context/TargetingSettingsContext';
import { type RequiredParamsType, RequiredTargetingSectionKeys, TargetingElementKeys } from '../../../../context/types';

export const useIsVideoStateCTVEquivalent = () => {
  const state = useTargetingSettingsContext((state: RequiredParamsType | null) => state);

  return useMemo((): boolean => {
    if (!state) return false;

    const formatElements = state.sections[RequiredTargetingSectionKeys.FORMAT]?.elements ?? [];
    const channelElements = state.sections[RequiredTargetingSectionKeys.CHANNEL]?.elements ?? [];
    const deviceElements = state.sections[RequiredTargetingSectionKeys.DEVICE]?.elements ?? [];

    const isFormatVideo = formatElements.some(
      element => element.mainOption.key === TargetingElementKeys.FORMAT_VIDEO && element.mainOption.isSelected
    );

    const selectedChannelKeys = channelElements.filter(el => el.mainOption.isSelected).map(el => el.mainOption.key);
    const isOnlyApp = selectedChannelKeys.length === 1 && selectedChannelKeys[0] === TargetingElementKeys.CHANNEL_APP;

    const selectedDeviceKeys = deviceElements.filter(el => el.mainOption.isSelected).map(el => el.mainOption.key);
    const isOnlyTvDevice = selectedDeviceKeys.length === 1 && selectedDeviceKeys[0] === TargetingElementKeys.DEVICE_TV;

    return isFormatVideo && isOnlyApp && isOnlyTvDevice;
  }, [state]);
};
